<template>
  <div class="nx-list-page">
    <dialog-reset v-loading="loading" slotShow height="65vh" width="1150px" top="10vh" title="变动详情"
      :visible.sync="show">
      <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page"
        :search.sync="query" :defaults.sync="defaults" @search-change="searchChange" @search-reset="searchReset"
        @refresh-change="refreshChange" @current-change="currentChange" @size-change="sizeChange">
      </avue-crud>
    </dialog-reset>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList } from "./api";
import { searchTimeConfig } from "@/basic-common/util/common";

export default {
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList },
      option: {
        ...this.$store.state.publicOption,
        menu: false,
        addBtn:false,
        column: [
          {
            label: '计划编号',
            prop: 'planNo',
          },
          {
            label: '计划名称',
            prop: 'planName',
          },
          {
            label: '业务类型',
            prop: 'businessType',
            overHidden: true, // 表格超出隐藏
            type: 'select',
            dataType: 'string',
            dicData: this.$store.getters.commonDict['businessType'],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '空车时间',
            prop: 'emptyTime',
          },
          {
            label: '重车时间',
            prop: 'heavyTime',
          },
          {
            label: '皮量（吨）',
            prop: 'grossWeight',
          },
          {
            label: '净重（吨）',
            prop: 'netWeight',
          },
          {
            label: '入库量（吨）',
            prop: 'weight',
          },
          {
            label: '库存剩余量',
            prop: 'stockRemain',
          },
          {
            label: '质检结果',
            prop: 'inspectionResult',
            type: 'select',
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=inspectionResult",
            dataType: "number",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
          },
        ]
      },
      show: false
    }
  },
  methods: {
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onLoad(this.page, this.query);
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.currentPage = 1;
      this.onLoad(this.page, this.query);
    },
    open(id) {
      this.show = true
      this.defaultParams = {
        stockExtId: id
      }
      this.$nextTick(() => {
        this.searchReset()
      })
    }
  }
}
</script>
<style scoped lang="scss"></style>
